
// Getters (GET*)
export const GET_SYSTEM_LIST = 'GET_SYSTEM_LIST';
export const GET_REGISTER_SYSTEM_FORM_VISIBILITY = 'GET_REGISTER_SYSTEM_FORM_VISIBILITY';
export const GET_SELECTED_SYSTEM = 'GET_SELECTED_SYSTEM';

// Actions (FETCH*, CREATE*, UPDATE*, DELETE*)
export const FETCH_SYSTEM_LIST = 'FETCH_SYSTEM_LIST';
export const CREATE_SYSTEM_LIST = 'CREATE_SYSTEM_LIST';
export const UPDATE_REGISTER_FORM_VISIBILITY = 'UPDATE_REGISTER_FORM_VISIBILITY';
export const UPDATE_SELECTED_SYSTEM = 'UPDATE_SELECTED_SYSTEM';
export const CREATE_NEW_SYSTEM = 'CREATE_NEW_SYSTEM';
export const UPDATE_SYSTEM_LIST = 'UPDATE_SYSTEM_LIST';
export const UPDATE_SYSTEM = 'UPDATE_SYSTEM';


// Mutations (SET*, ADD*, REMOVE*)
export const SET_SYSTEM_LIST = 'SET_SYSTEM_LIST';
export const SET_REGISTER_FORM_VISIBILITY = 'SET_REGISTER_FORM_VISIBILITY';
export const SET_SELECTED_SYSTEM = 'SET_SELECTED_SYSTEM';
export const ADD_SYSTEM_TO_LIST = 'ADD_SYSTEM_TO_LIST';


